export default function omit(object, fields) {
    const newObject = { ...object };
    fields.forEach((field) => delete newObject[field]);
    return newObject;
}
